import React from "react";
import { useMediaQuery } from "react-responsive";
import { NoticeListContainer } from "../styled";
import { useOutletContext } from "react-router";

const List = ({ data, clickEvent, header, type, className }) => {
  const { theme } = useOutletContext();
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });

  return (
    <NoticeListContainer className={`theme-${theme}`}>
      <li className="header">
        {header.map((item) => (
          <span className={item.key}>{item.name}</span>
        ))}
      </li>
      {data && data.length > 0 ? (
        data.map((ele) => (
          <li onClick={() => clickEvent(ele)}>
            {header.map((item) => (
              <>
                {item.content ? (
                  item.content(ele)
                ) : (
                  <span className={item.key}>{ele[item.key]}</span>
                )}
              </>
            ))}
          </li>
        ))
      ) : (
        <li className="not">{chooseParticle(type, "이가")} 존재하지 않습니다.</li>
      )}
    </NoticeListContainer>
  );
};

export default List;
